import React from 'react';
import { IUpsellProgressBar } from '../interfaces';

interface IProgressBarType4Props {
    progressBar: IUpsellProgressBar;
}

const ProgressBarType4 = ({ progressBar }: IProgressBarType4Props) => {
    return (
        <div
            role="progressbar"
            aria-labelledby="free-plugin-progress-label"
            aria-valuemin={ progressBar.min }
            aria-valuemax={ progressBar.max }
            aria-valuenow={ progressBar.value }
            aria-valuetext={ progressBar.ariaText }
            className="w-full border border-green rounded bg-green-100"
        >
            <div
                className="h-full bg-green"
                style={{
                    width: `${ progressBar.percent }%`,
                    height: '5px',
                }}
            />
        </div>
    )
};

export default ProgressBarType4;